<template>
  <div class="row mb-2 py-2 bg-white shadow mx-0 rounded application-row" @click="openApplication()">
    <div class="col my-auto">{{ application.titel }}</div>
  </div>
</template>

<script lang="ts" setup>
  //#region Imports
  import { PropType } from 'vue';
  import { useRouter } from 'vue-router';
  import { Application } from '@/models/ApplicationsModels';

  //#endregion

  const { application } = defineProps({
    application: {
      type: Object as PropType<Application>,
      required: true
    }
  });

  const router = useRouter();

  function openApplication() {
    router.push({ name: 'ApplicationDetails', params: { id: application.id } });
  }
</script>

<style lang="scss" scoped>
  .application-row:hover {
    cursor: pointer;
    transition: background-color 0.3s;

    &:hover {
      background-color: #cee0fa !important;
    }
  }
  </style>